// extracted by mini-css-extract-plugin
export default {"productDetail":"productDetail_productDetail__xou5Z","wrapper":"productDetail_wrapper__U7uR7","coverImg":"productDetail_coverImg__6H9WO"};